module.exports = __webpack_public_path__ + "assets/images/home/background.333e5aff7456537a968c162dce03fdfc.webp";